<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de campanha">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'imunizacao-cadastro-campanha-create' })"
                    authorize="store-imunizacao-cadastro-campanha"
                    color="primary"
                >
                    Cadastrar campanha
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/imunizacao/cadastro-campanha/List'

export default {
    components: { List },
}
</script>